import { resolveMethodAssignment } from 'features/libra/inspectionPlanning/methodAssignments'
import { InspectionArea } from 'features/libra/inspectionPlanning/planningTypes'
import { formatScope } from 'features/libra/inspectionPlanning/scopeMeasurement'
import { TechniqueCatalogue } from 'features/libra/inspectionPlanning/techniqueTypes'
import { GeckoMeasurementSystem } from 'types'

import { WorkPackSection } from './workPackTypes'

export function buildMethodWorkPackSections(
  area: InspectionArea,
  index: number,
  catalogue: TechniqueCatalogue,
  measurementSystem: GeckoMeasurementSystem
): WorkPackSection[] {
  const methods = area.methodAssignments.map((method) =>
    resolveMethodAssignment(method, catalogue)
  )
  return [
    {
      title: `P${index + 1} - ${area.title}`,
      rows: [
        { label: 'Scope reference', value: area.id },
        {
          label: 'Location',
          value:
            area.scope === 'zone'
              ? 'Whole source zone; no box required'
              : `Box P${index + 1} on drawing ${area.zone_reference_image_id}`,
        },
        {
          label: 'Degradation',
          value:
            catalogue.degradationTypes.find(
              (item) => item.id === area.degradationTypeId
            )?.label ?? 'Not specified',
        },
        {
          label: 'Selected methods',
          value:
            methods.map((method) => method.method).join(', ') ||
            'Not specified',
        },
      ],
    },
    ...methods.map((method) => {
      const technique = catalogue.techniques.find(
        (item) => item.id === method.techniqueId
      )
      return {
        title: `P${index + 1} - ${method.method}`,
        rows: [
          { label: 'Method reference', value: method.id },
          {
            label: 'Procedure / specification',
            value: method.procedure || 'Not specified',
          },
          {
            label: 'Site instructions',
            value: method.instructions || 'Not specified',
          },
          {
            label: 'Estimated scope',
            value: method.scopeType
              ? formatScope(
                  method.estimatedScope,
                  method.scopeType,
                  measurementSystem,
                  catalogue.units.count
                )
              : 'Scope units await confirmation',
          },
          ...(technique
            ? [
                {
                  label: 'Technique notes / POD',
                  value: `${technique.description}\nPOD: ${technique.pod === null ? 'Not specified' : `${technique.pod * 100}%`}`,
                },
              ]
            : []),
        ],
      }
    }),
  ]
}
